import NotImplementedError from '../errors/NotImplementedError';

export default class Connection {

    constructor() {
        this.channels = {};
    }

    disconnect() {
        throw new NotImplementedError('disconnect');
    }

    state() {
        throw new NotImplementedError('state');
    }

    subscribe(channelName, channelClass) { // eslint-disable-line
        throw new NotImplementedError('subscribe');
    }

    unsubscribe(channelName, channelClass) { // eslint-disable-line
        throw new NotImplementedError('unsubscribe');
    }

    getChannel(channelName, channelClass) { // eslint-disable-line
        throw new NotImplementedError('getChannel');
    }
}
